module.exports = __webpack_public_path__ + "img/header.781a43fe.jpg";